export default {
  loaded(state) {
    state.loaded = true
  }
}